export const admin = {
    namespaced: true,
    state: {
      selectedKlass: null
    },
    mutations: {
      setSelectedKlass(state, klass) {
        state.selectedKlass = klass;
      },
    },
  };